<template>
  <!-- 基础弹窗组件 -->
  <transition name="fade" mode="out-in">
    <div :class="['popup', popupClass]" v-show="visible">
      <div
        class="popup-mask"
        @click="maskClosable ? handleClose() : null"
      ></div>

      <!-- 关闭按钮 - 相对于 .popup 定位 -->
      <div
        v-if="showCloseBtn"
        class="popup-close-btn"
        @click="handleClose"
      ></div>

      <div class="popup-content">
        <!-- 标题 -->
        <div v-if="title" class="popup-content-title">{{ title }}</div>

        <!-- 内容区域 -->
        <div class="popup-content-text" :style="contentStyle">
          <slot></slot>
        </div>

        <!-- 确认按钮 -->
        <div
          v-if="showConfirmBtn"
          class="popup-content-confirm-btn"
          @click="handleConfirm"
        ></div>

        <!-- 底部插槽 -->
        <slot name="footer"></slot>
      </div>
    </div>
  </transition>
</template>

<script setup>

// 定义props
const props = defineProps({
  // 控制显示/隐藏
  visible: {
    type: Boolean,
    default: false,
  },
  // 弹窗的自定义class
  popupClass: {
    type: String,
    default: "",
  },
  // 标题
  title: {
    type: String,
    default: "",
  },
  // 是否显示关闭按钮
  showCloseBtn: {
    type: Boolean,
    default: true,
  },
  // 是否显示确认按钮
  showConfirmBtn: {
    type: Boolean,
    default: false,
  },
  // 点击遮罩是否可以关闭
  maskClosable: {
    type: Boolean,
    default: true,
  },
  // 内容样式
  contentStyle: {
    type: [String, Object],
    default: '',
  },
});

// 定义emits
const emit = defineEmits(["close", "update:visible", "confirm"]);

// 关闭弹窗
const handleClose = () => {
  emit("close");
  emit("update:visible", false);
};

// 确认
const handleConfirm = () => {
  emit("confirm");
  emit("update:visible", false);
};
</script>

<style scoped>
/* 基础样式在全局 popup.less 文件中定义 */
</style>
